// Do not modify directly
// Generated from file: learnin.core.api/ViewModels/Payments/TransactionState.cs

enum TransactionState {
  Authorization,
  Transaction,
}

export default TransactionState;
